import React, { useEffect } from 'react'
import { Form, Modal } from 'antd';
import ItemWikiForm from './ItemWikiForm';

export default function ItemWikiModal({isModalVisible, setIsModalVisible, refresh, record, tools, allItems}){
    const [form] = Form.useForm()

    function handleOk() {
        setIsModalVisible(false);
    }

    function handleCancel() {
        setIsModalVisible(false);
    }

    useEffect(() => {
        form.setFieldsValue(record)
    },     //eslint-disable-next-line
    [form, record])

    return (
            <Modal 
                title={`[${record?.id}] ${record?.name}`}  
                visible={isModalVisible} 
                onOk={handleOk} 
                onCancel={handleCancel}
                footer={null}
                width={"80%"}
                
            >
                <ItemWikiForm 
                    form={form}
                    record={record}
                    tools={tools}
                    allItems={allItems}
                />
            </Modal>
    )
}